// material-ui
import { styled } from '@mui/material/styles';
import Popper from '@mui/material/Popper';

// ==============================|| NAVIGATION - MINI FLYOUT POPPER (comun) ||============================== //
// Panoul flyout din meniul restrâns (săgeată spre iconiță, variantă `right-end` cu
// săgeata jos la flip) — FOLOSIT ATÂT de collapse-uri (NavCollapse), cât și de itemele
// simple (NavItem), ca toate intrările să aibă același comportament/aspect.

const PopperStyled = styled(Popper)(({ theme }) => ({
  overflow: 'visible',
  zIndex: 1202,
  minWidth: 180,
  '& > .MuiBox-root': {
    position: 'relative',
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 25,
      ...(theme.direction !== 'rtl' && { left: -5 }),
      ...(theme.direction === 'rtl' && { right: -5 }),
      width: 10,
      height: 10,
      background: theme.vars.palette.background.paper,
      transform: 'translateY(-50%) rotate(45deg)',
      zIndex: 120,
      borderLeft: '2px solid',
      borderLeftColor: theme.vars.palette.divider,
      borderBottom: '2px solid',
      borderBottomColor: theme.vars.palette.divider
    }
  },
  '&[data-popper-placement="right-end"]': {
    '.MuiPaper-root': {
      marginBottom: -8
    },
    '&:before': {
      top: 'auto',
      bottom: 5
    }
  }
}));

export default PopperStyled;
